import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useDispatch,useSelector } from "react-redux";
import { getShopsOfcView } from "../../../store/actions/shopAction";
import { Loader, htmlDecode } from '../../../utils/tools';
import { getUserData } from '../../../utils/tools';
import ShopStatusChange from "../../../utils/shopStatusChange";
import ShopContentStatusChange from "../../../utils/shopContentStatusChange";
import Divider from '@mui/material/Divider' ;
import ShopContactInfo from "../../../utils/shopContactInfo";
import ShopAdressCard from "../../../utils/shopAdressCard";
import ShopTimingCard from "../../../utils/shopTimingCard";
import ShopContentViewCard from "../../../utils/shopContentViewCard";
import Button from '@mui/material/Button';
import { shopImageStatusChange } from "../../../store/actions/shopAction";

const ShopInfoOfcView =()=>{
   
    const shopinfo= useSelector(state=>state.shopReducer);
    const dispatch = useDispatch();
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(()=>{
        dispatch(getShopsOfcView(id))
        .unwrap()
        .then(()=>{
         //navigate(`/`)
   
          
        })
     },[id,dispatch])



     const goToNewsAproval = (id,trnsNo,sats,type) => {
         

        if(type==="cont"){
            
          
            //dispatch(getPaginateArticles({page}))
            const data = {
                shopId:id,
                approved:getUserData().userId,
                trsnNo:trnsNo,
                status:sats
               
                
          };
          const addURL="api/shpscntnt/aprve";
            
        
      dispatch(shopImageStatusChange({data,addURL}))
                  .unwrap()
                  .then(()=>{
                   //navigate(`/dashboard/articlesOfc/article/${id}`)
                   window.location.reload();
                    
                  })
            
              }
              else{
                  //console.log(page)
            //dispatch(getPaginateArticles({page}))
            const data = {
                id:id,
                creatorID:getUserData().userId,
                createrName:getUserData().userName
               
              
          };
          const addURL="api/shops/shpaprv";
            
      
      dispatch(shopImageStatusChange({data,addURL}))
                  .unwrap()
                  .then(()=>{
                   navigate(`/dashboard/status`)
             
                    
                  })
            
                  
              }
        
    }

    const goToNewsPublish = (id,trnsNo,sats,type) => {
        

        if(type==="cont"){
            
          
            //dispatch(getPaginateArticles({page}))
            const data = {
                shopId:id,
                approved:getUserData().userId,
                trsnNo:trnsNo,
                status:sats
               
                
          };
          const addURL="api/shpscntnt/pblsh";
            
        
      dispatch(shopImageStatusChange({data,addURL}))
                  .unwrap()
                  .then(()=>{
                   //navigate(`/dashboard/articlesOfc/article/${id}`)
                   window.location.reload();
                    
                  })
            
              }
        else{
            //console.log(page)
      //dispatch(getPaginateArticles({page}))
      const data = {
        id:id,
        creatorID:getUserData().userId,
        createrName:getUserData().userName
       
      
  };
  const addURL="api/shops/shppbls";
    
      

dispatch(shopImageStatusChange({data,addURL}))
            .unwrap()
            .then(()=>{
             navigate(`/`)
       
              
            })
      
            
        }
    }  

    const goToNewsBlock = (id,trnsNo,sats,type) => {
          

        if(type==="cont"){
            
          
            //dispatch(getPaginateArticles({page}))
            const data = {
                shopId:id,
                approved:getUserData().userId,
                trsnNo:trnsNo,
                status:sats
               
                
          };
          const addURL="api/shpscntnt/block";
            
        
      dispatch(shopImageStatusChange({data,addURL}))
                  .unwrap()
                  .then(()=>{
                   //navigate(`/dashboard/articlesOfc/article/${id}`)
                   window.location.reload();
                    
                  })
            
              }
              else{
                  //console.log(page)
            //dispatch(getPaginateArticles({page}))
            const data = {
                id:id,
                creatorID:getUserData().userId,
                createrName:getUserData().userName
               
              
          };
          const addURL="api/shops/shpblk";
            
      
      dispatch(shopImageStatusChange({data,addURL}))
                  .unwrap()
                  .then(()=>{
                   navigate(`/dashboard/articlesOfc/article/${id}`)
             
                    
                  })
            
                  
              }
    }  

    const  goToNewsNewsImageView=() => {
        //console.log(page)
        //dispatch(getPaginateArticles({page}))
        console.log(id)
        navigate(`/dashboard/shop/imageupload/${id}`)
        
        
    }  
   

    return(
        <>
            { shopinfo && shopinfo.current?
                <div className='article_container'>
                    

                    
                    {shopinfo.current.imageList.length>0 ?
                    <div
                        style={{
                            background:`url(${shopinfo.current.imageList[0].imageUrl})`
                            
                        }}
                        className="image"
                    >
                        <div>
                        <Button
                                             className='mt-3'
                                            variant='contained'
                                            color='error'
                                            onClick={()=>goToNewsNewsImageView(shopinfo.current.shopId)}
                                            >
                                               Image View
                                               
                                                
                                                </Button>
                            </div>

                                     
                    </div>
                    :null
}                     
                 
                    <h1>{shopinfo.current.shopName}</h1>
                   

                    <div>
                    <Divider className='mt-3 mb-3'/>
                    {(shopinfo.current.languageType==1)?
                    
                    <div>
                    <h5>LANGUAGE : ENGLISH</h5>
                   </div>
                   :<div>
                   <h5>LANGUAGE : KANNADA</h5>
                   </div>}
                   <Divider className='mt-3 mb-3'/>
                
                    </div>
                    <h3>{shopinfo.current.status}</h3>
                    <Divider className='mt-3 mb-3'/>
                    <h5> SUB TITLE</h5>
                    <h5>{shopinfo.current.shopTitle}</h5>
                    <Divider className='mt-3 mb-3'/>

                    



                    <>
                    {!((getUserData().role==="ROLE_SHOPRPTR") || (getUserData().role==="ROLE_SHOPPBSR"))?

            <ShopStatusChange
                    shopinfo={shopinfo}
                    type="Shop Name"
                    goToNewsAproval={(id)=> goToNewsAproval(shopinfo.current.shopId,shopinfo.current.contentList[0].trsnNo,"test")}
                    goToNewsPublish={(id)=> goToNewsPublish(shopinfo.current.shopId,shopinfo.current.contentList[0].trsnNo,"test")}
                    goToNewsBlock={(id)=> goToNewsBlock(shopinfo.current.shopId,shopinfo.current.contentList[0].trsnNo,"test")}
                    status={shopinfo.current.status}
                    

                />
                :null  }
            </>
            

          
            <div className='contentcard'>    
            <h2>Store Content</h2>
                    
                    { shopinfo.current.contentList.length>0 ?
                    <div >

                { shopinfo.current.contentList.map((item,i)=>(
                                            
                                            <div key={i}>
                               
                               

                               

                               

                  <ShopContentViewCard item={item}/>
                  {!((getUserData().role==="ROLE_SHOPRPTR") || (getUserData().role==="ROLE_SHOPPBSR"))?

                    <ShopContentStatusChange
                    shop={item}
                        type="Shop Content"
                        goToNewsAproval={(id)=> goToNewsAproval( item.shopId,item.trsnNo,item.status,"cont")}
                        goToNewsPublish={(id)=> goToNewsPublish(item.shopId,item.trsnNo,item.status,"cont")}
                        goToNewsBlock={(id)=> goToNewsBlock(item.shopId,item.trsnNo,item.status,"cont")}
                        status={item.status}
                                            
                        

                                        />  
                                        :null  }   
                                        </div>
                                            
                                            ))}
                        
                        
                   
                        
                        
                        

                            
              
                
                    </div>
                    :null
}                      
</div> 

                  <ShopContactInfo current={shopinfo.current}/>

                  <ShopAdressCard current={shopinfo.current}/>
                  <ShopTimingCard current={shopinfo.current}/>

                  
                </div>
            :
                <Loader/>
            }
        </>
    )
    
}

export default ShopInfoOfcView
